<template>
  <div>
    <div class="row invisible-print">
      <div class="col-md-12">
        <label>Data busca:</label>
        <date-range-picker
          ref="date-range-picker"
          opens="left"
          :locale-data="localData"
          :autoApply="true"
          :disabled="isLoading"
          v-model="dateRange"
          :ranges="ranges"
          @update="updateDatas"
          style="width: 100%"
        >
          <template v-slot:input="picker">
            <div v-if="picker.startDate && picker.endDate" style="min-width: 350px">
              {{ formataDataObject(picker.startDate) }} à
              {{ formataDataObject(picker.endDate) }}
            </div>
          </template>
        </date-range-picker>
      </div>
    </div>
    <div class="row invisible-print" style="margin-top: 8px; margin-bottom: 16px;">
      <div class="col-md-12">
        <a
          href="javascript:;"
          @click="buscar"
          class="btn btn-block btn-primary font-weight-bolder mr-2"
          :disabled="isLoading"
        >
          <b-spinner
            v-if="isLoading"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Buscar
        </a>
      </div>
    </div>
    <div class="row" v-if="transferencias.length">
      <div class="col-md-12">
        <div class="card card-custom position-relative overflow-hidden">
          <div class="position-absolute opacity-30">
            <span class="svg-icon svg-icon-10x svg-logo-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="176"
                height="165"
                viewBox="0 0 176 165"
                fill="none"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M-10.001 135.168C-10.001 151.643 3.87924 165.001 20.9985 165.001C38.1196 165.001 51.998 151.643 51.998 135.168C51.998 118.691 38.1196 105.335 20.9985 105.335C3.87924 105.335 -10.001 118.691 -10.001 135.168Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M28.749 64.3117C28.749 78.7296 40.8927 90.4163 55.8745 90.4163C70.8563 90.4163 83 78.7296 83 64.3117C83 49.8954 70.8563 38.207 55.8745 38.207C40.8927 38.207 28.749 49.8954 28.749 64.3117Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M82.9996 120.249C82.9996 144.964 103.819 165 129.501 165C155.181 165 176 144.964 176 120.249C176 95.5342 155.181 75.5 129.501 75.5C103.819 75.5 82.9996 95.5342 82.9996 120.249Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M98.4976 23.2928C98.4976 43.8887 115.848 60.5856 137.249 60.5856C158.65 60.5856 176 43.8887 176 23.2928C176 2.69692 158.65 -14 137.249 -14C115.848 -14 98.4976 2.69692 98.4976 23.2928Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M-10.0011 8.37466C-10.0011 20.7322 0.409554 30.7493 13.2503 30.7493C26.0911 30.7493 36.5 20.7322 36.5 8.37466C36.5 -3.98287 26.0911 -14 13.2503 -14C0.409554 -14 -10.0011 -3.98287 -10.0011 8.37466Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M-2.24881 82.9565C-2.24881 87.0757 1.22081 90.4147 5.50108 90.4147C9.78135 90.4147 13.251 87.0757 13.251 82.9565C13.251 78.839 9.78135 75.5 5.50108 75.5C1.22081 75.5 -2.24881 78.839 -2.24881 82.9565Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M55.8744 12.1044C55.8744 18.2841 61.0788 23.2926 67.5001 23.2926C73.9196 23.2926 79.124 18.2841 79.124 12.1044C79.124 5.92653 73.9196 0.917969 67.5001 0.917969C61.0788 0.917969 55.8744 5.92653 55.8744 12.1044Z"
                    fill="#AD84FF"
                  ></path>
                </g>
              </svg>
            </span>
          </div>
          <div
            class="
              row
              justify-content-center
              py-8
              px-8
              py-md-36
              px-md-0
              bg-primary
            "
          >
            <div class="col-md-9">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-md-center
                  flex-column flex-md-row
                "
              >
                <div class="d-flex flex-column px-0 order-2 order-md-1">
                  <a href="#" class="mb-5 max-w-115px">
                    <span class="svg-icon svg-icon-full svg-logo-white">
                      <img src="media/logos/paylogos_logo2.png" style="height: 50px; margin-left: -14px;" />
                    </span>
                  </a>
                  <span
                    class="
                      d-flex
                      flex-column
                      font-size-h5 font-weight-bold
                      text-white
                    "
                  >
                    <span>Relatório de recebíveis pagos por {{ retornaTituloBuscaData() }}</span>
                    <span>{{ formataDataObject(dateRange.startDate) }} à {{ formataDataObject(dateRange.endDate) }}</span>
                  </span>
                </div>
                <h1
                  class="
                    display-3
                    font-weight-boldest
                    text-white
                    order-1 order-md-2
                  "
                  style="font-size: 40px !important;"
                >
                  TRANSFERÊNCIAS
                </h1>
              </div>
            </div>
          </div>
          <div class="row justify-content-center py-8 px-8 py-md-30 px-md-0" v-for="transferencia in transferencias" :key="transferencia.id">
            <div class="col-md-12">
              <div style="margin-bottom: 34px;">
                <div class="col-md-12" style="padding-left: 30px; padding-right: 30px;">
                  <h5>
                    Transferência {{ transferencia.id }} em {{ retornaDataFormatada(transferencia.created_at) }}
                  </h5>
                  <h5>
                    Quantidade de Transações: {{ transferencia.transactions.length }}
                  </h5>
                </div>
              </div>
              <div class="row" style="margin-left: 20px; margin-right: 20px;">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Data da Venda
                          </th>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Descrição
                          </th>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Dados Transação
                          </th>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Forma de Pagamento
                          </th>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Status
                          </th>
                          <th class="pt-1 pb-9 font-weight-bolder text-muted font-size-lg text-uppercase">
                            Valores
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="font-weight-bolder border-bottom-0 font-size-lg" v-for="transacao in transferencia.transactions" :key="transacao.id">
                          <td class="border-top-0 py-4">
                            {{ retornaDataFormatada(transacao.created_at) }}
                          </td>
                          <td class="border-top-0 py-4">
                            {{ transacao.description }}
                          </td>
                          <td class="border-top-0 py-4">
                            <span style="white-space: nowrap;">
                              Código: {{ transacao.id }}
                            </span><br />
                            <span style="white-space: nowrap;">
                              Nome: {{ transacao.COMPRADOR.NOME }}
                            </span><br />
                            <span style="white-space: nowrap;">
                              CPF ou CNPJ: {{ transacao.COMPRADOR.CPF_CNPJ }}
                            </span>
                          </td>
                          <td class="border-top-0 py-4">
                            {{ (transacao.payment_type == "credit") ? "Crédito" : transacao.payment_type }}
                            <span v-if="transacao.payment_type == 'credit'">
                              - {{ transacao.payment_method.card_brand }} - {{ transacao.installment_plan.installment_number }} / {{ transacao.installment_plan.number_installments }}
                            </span><br />
                            <span v-if="transacao.payment_type == 'credit'">
                              Autorização: {{ transacao.TRANSACAO_ATUALIZADA.payment_authorization.authorization_code }}
                            </span>
                          </td>
                          <td class="border-top-0 py-4">
                            {{ transacao.status }}
                          </td>
                          <td class="border-top-0 py-4">
                            Venda: {{ retornaValorTotal(transacao.TRANSACAO_ATUALIZADA.amount) }}<br />
                            Transferência: {{ retornaValorTotal(transacao.amount) }} <br />
                            Bruto: {{ retornaValorTotal(transacao.TRANSACAO_ATUALIZADA.amount) }} <br />
                            Líquido: {{ retornaValorTotalLiquido(transacao) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-left: 20px; margin-right: 20px;">
                <div class="col-md-5 pt-14 pb-10 pb-md-18">
                  <div class="d-flex flex-column flex-md-row">
                    <div class="d-flex flex-column">
                      <div class="font-weight-bold font-size-h6 mb-3">
                        TRANSFERÊNCIA BANCÁRIA
                      </div>
                      <div class="d-flex justify-content-between font-size-lg mb-3">
                        <span class="font-weight-bold mr-15">
                          Banco:
                        </span>
                        <span class="text-right">
                          {{ transferencia.bank_account.bank_name }} ({{ transferencia.bank_account.bank_code }})
                        </span>
                      </div>
                      <div class="d-flex justify-content-between font-size-lg mb-3">
                        <span class="font-weight-bold mr-15">
                          Agência e Conta:
                        </span>
                        <span class="text-right">
                          {{ transferencia.bank_account.routing_number }} - {{ transferencia.bank_account.account_number }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between font-size-lg">
                        <span class="font-weight-bold mr-15">
                          CNPJ:
                        </span>
                        <span class="text-right">
                          {{ transferencia.bank_account.taxpayer_id }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-7 pt-md-25">
                  <div
                    class="
                      bg-primary
                      rounded
                      d-flex
                      align-items-center
                      justify-content-between
                      text-white
                      max-w-350px
                      position-relative
                      ml-auto
                      p-7
                    "
                  >
                    <div class="position-absolute opacity-30 top-0 right-0">
                      <span
                        class="
                          svg-icon svg-icon-2x svg-logo-white svg-icon-flip
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="176"
                          height="165"
                          viewBox="0 0 176 165"
                          fill="none"
                        >
                          <g clip-path="url(#clip0)">
                            <path
                              d="M-10.001 135.168C-10.001 151.643 3.87924 165.001 20.9985 165.001C38.1196 165.001 51.998 151.643 51.998 135.168C51.998 118.691 38.1196 105.335 20.9985 105.335C3.87924 105.335 -10.001 118.691 -10.001 135.168Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M28.749 64.3117C28.749 78.7296 40.8927 90.4163 55.8745 90.4163C70.8563 90.4163 83 78.7296 83 64.3117C83 49.8954 70.8563 38.207 55.8745 38.207C40.8927 38.207 28.749 49.8954 28.749 64.3117Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M82.9996 120.249C82.9996 144.964 103.819 165 129.501 165C155.181 165 176 144.964 176 120.249C176 95.5342 155.181 75.5 129.501 75.5C103.819 75.5 82.9996 95.5342 82.9996 120.249Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M98.4976 23.2928C98.4976 43.8887 115.848 60.5856 137.249 60.5856C158.65 60.5856 176 43.8887 176 23.2928C176 2.69692 158.65 -14 137.249 -14C115.848 -14 98.4976 2.69692 98.4976 23.2928Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M-10.0011 8.37466C-10.0011 20.7322 0.409554 30.7493 13.2503 30.7493C26.0911 30.7493 36.5 20.7322 36.5 8.37466C36.5 -3.98287 26.0911 -14 13.2503 -14C0.409554 -14 -10.0011 -3.98287 -10.0011 8.37466Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M-2.24881 82.9565C-2.24881 87.0757 1.22081 90.4147 5.50108 90.4147C9.78135 90.4147 13.251 87.0757 13.251 82.9565C13.251 78.839 9.78135 75.5 5.50108 75.5C1.22081 75.5 -2.24881 78.839 -2.24881 82.9565Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M55.8744 12.1044C55.8744 18.2841 61.0788 23.2926 67.5001 23.2926C73.9196 23.2926 79.124 18.2841 79.124 12.1044C79.124 5.92653 73.9196 0.917969 67.5001 0.917969C61.0788 0.917969 55.8744 5.92653 55.8744 12.1044Z"
                              fill="#AD84FF"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div class="font-weight-boldest font-size-h5">
                      VALOR TOTAL
                    </div>
                    <div class="text-right d-flex flex-column">
                      <span class="font-weight-boldest font-size-h3 line-height-sm">
                        {{ retornaValorTotal(transferencia.amount) }}
                      </span>
                      <span class="font-size-sm"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              row
              justify-content-center
              border-top
              py-8
              px-8
              py-md-28
              px-md-0 
              invisible-print
            "
          >
            <div class="col-md-9">
              <div class="d-flex font-size-sm flex-wrap">
                <button
                  type="button"
                  class="
                    btn btn-block btn-primary
                    font-weight-bolder
                    py-4
                    mr-3 mr-sm-14
                    my-1
                  "
                  onclick="window.print();"
                  style="margin: 0 !important;"
                >
                  Imprimir Relatório
                </button>
                <button
                  type="button"
                  class="
                    btn btn-block btn-primary
                    font-weight-bolder
                    py-4
                    mr-3 mr-sm-14
                    my-1
                  "
                  @click="exportarExcel"
                  style="margin: 0 !important; margin-top: 10px !important;"
                >
                  Exportar Relatório Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Transferencias",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      isLoading: false,
      dataFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" },
      ],
      ordenacaoFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" },
        { value: "valor", text: "Valor" },
      ],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      localData: {
        firstDay: 1,
        format: "yyyy-mm-dd HH:mm:ss",
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        monthNames: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
      },
      ranges: {
        Hoje: [moment().toDate(), moment().toDate()],
        Ontem: [
          moment().subtract(1, "days").toDate(),
          moment().subtract(1, "days").toDate(),
        ],
        "Mês atual": [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate(),
        ],
        "Mês passado": [
          moment().subtract(1, "month").startOf("month").toDate(),
          moment().subtract(1, "month").endOf("month").toDate(),
        ],
        "Ano atual": [
          moment().startOf("year").toDate(),
          moment().endOf("year").toDate(),
        ],
      },
      transferencias: []
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Relatórios", route: "transferencias" },
      { title: "Transferências" },
    ]);

    moment.locale("pt-br");

    this.dateRange.startDate = moment().toDate();
    this.dateRange.endDate = moment().toDate();
  },
  computed: {
    ...mapGetters([
      "emitentePrincipal"
    ])
  },
  methods: {
    ...mapActions([
      "getRelatoriosTransferencias"
    ]),
    setOrdenacaoData() {},
    setFiltroData() {},
    updateDatas() {},
    formataDataObject(data) {
      if (data) {
        return moment(data).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    async buscar() {
      this.isLoading = true;
      let transferencias = await this.getRelatoriosTransferencias({
        dataIni: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        dataFim: moment(this.dateRange.endDate).format("YYYY-MM-DD")
      });

      transferencias.forEach((transferencia) => {
        transferencia.transactions.forEach((transacao) => {
          if((!transacao.COMPRADOR) || (!transacao.COMPRADOR.NOME)) {
            transacao.COMPRADOR = {};
            if(transacao.TIPO_PAGAMENTO == "credit") {
              transacao.COMPRADOR.NOME = transacao.TRANSACAO_MICROLOGOS.CARTAO_NOME;
            }
          }
        });
      });

      this.transferencias = transferencias;

      this.isLoading = false;
    },
    retornaDescricaoFluxo(fluxo) {
      return (fluxo.PROJETO) ? fluxo.PROJETO : fluxo.HISTORICO;
    },
    retornaCPFCNPJFormatado(fluxo) {
      if(fluxo.EMITENTE_CGC_CPF) {
        if(fluxo.EMITENTE_PESSOA == "F") {
          return fluxo.EMITENTE_CGC_CPF.replace(/[^\d]/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else {
          return fluxo.EMITENTE_CGC_CPF.replace(/[^\d]/g, "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
      } else {
        return "";
      }
    },
    formataData(data) {
      return moment(data, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY");
    },
    formataValor(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    retornaValorTotal(valor) {
      return parseFloat(valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    retornaValorTotalLiquido(transacao) {
      return this.retornaValorTotal(parseFloat(transacao.TRANSACAO_ATUALIZADA.amount) - parseFloat(transacao.TRANSACAO_ATUALIZADA.fees));
    },
    retornaTituloBuscaData() {
      let titulo = "";
      
      return titulo;
    },
    retornaTransacaoId(fluxo) {
      if((fluxo.TRANSACAO) && (fluxo.TRANSACAO.ID_ZOOP_API)) {
        return fluxo.TRANSACAO.ID_ZOOP_API;
      } else {
        return "";
      }
    },
    retornaTransacaoAutorizacao(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.MOVIMENTO) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization.authorization_code)
      ) {
        return "Autorização: " + fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization.authorization_code;
      } else {
        return "";
      }
    },
    retornaFormaPagamento(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.TIPO_PAGAMENTO)
      ) {
        if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "credit") {
          return "Crédito";
        } else if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "boleto") {
          return "Boleto";
        } else if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "pix") {
          return "PIX";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    retornaBandeiraCartao(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.CARTAO_BANDEIRA)
      ) {
        return fluxo.TRANSACAO.CARTAO_BANDEIRA;
      } else {
        return "";
      }
    },
    retornaParcelas(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.PARCELAS)
      ) {
        return fluxo.TRANSACAO.PARCELAS;
      } else {
        return "";
      }
    },
    retornaDataFormatada(data) {
      return moment(data.substring(0, 19), "YYYY-MM-DD[T]HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    },
    exportarExcel() {
      let items = "Data da Venda;Descrição;Emitente;CPF;Código;Forma de Pagamento;Autorização;Status;Valor da Venda;Valor da Transferência;Valor Bruto;Valor Líquido\n";

      this.transferencias.forEach((transferencia) => {
        transferencia.transactions.forEach((transacao) => {
          let sAux = this.retornaDataFormatada(transacao.created_at) + ";" +
            transacao.description + ";" +
            transacao.COMPRADOR.NOME + ";" +
            transacao.COMPRADOR.CPF_CNPJ + ";" +
            transacao.id + ";" +
            ((transacao.payment_type == "credit") ? "Crédito" : transacao.payment_type) + ((transacao.payment_type == "credit") ? (" - " + transacao.payment_method.card_brand + " - " + transacao.installment_plan.installment_number + " / " + transacao.installment_plan.number_installments) : "") + ";" +
            ((transacao.payment_type == "credit") ? transacao.TRANSACAO_ATUALIZADA.payment_authorization.authorization_code : "") + ";" +
            transacao.status + ";" +
            this.retornaValorTotal(transacao.TRANSACAO_ATUALIZADA.amount) + ";" +
            this.retornaValorTotal(transacao.amount) + ";" +
            this.retornaValorTotal(transacao.TRANSACAO_ATUALIZADA.amount) + ";" +
            this.retornaValorTotalLiquido(transacao) + "\n";

          items += sAux;
        });
      });

      let element = document.createElement('a');
      let universalBOM = "\uFEFF";
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + items));
      element.setAttribute('download', 'relatorio_transferencias' + moment(this.dateRange.startDate).format("YYYY-MM-DD") + '-a-' + moment(this.dateRange.endDate).format("YYYY-MM-DD") + '.csv');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }
}
</script>

<style>
.calendars .ranges {
  max-width: 140px;
}

.vue-daterange-picker .reportrange-text {
  padding-top: 9px;
  text-align: center;
  border: 1px solid #e4e6ef;
}

.vue-daterange-picker .reportrange-text i {
  display: none;
}

@media (max-width: 767px) {
  .mrg-bottom-cel {
    margin-bottom: 8px;
  }
}
</style>